// extracted by css-extract-rspack-plugin
export default {"root":"root-PCkXly text-base","description":"description-DCeDS6"};